import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CoursesService } from '@services/courses.service';
import { NewlevelComponent } from './newlevel/newlevel.component';
import Swal from 'sweetalert2';
import { LevelsService } from '@services/levels.service';
import { KeywordTypeService } from '@services/keywordType.service';
import { KeywordtypeComponent } from './keywordtype/keywordtype.component';
@Component({
  selector: 'app-coursedetail',
  templateUrl: './coursedetail.component.html',
  styleUrls: ['./coursedetail.component.css']
})
export class CoursedetailComponent implements OnInit {
  course:any;
  keywordTypes:any[]=[];
  id:any;
  constructor(
    private levelService:LevelsService,
    private modal:NgbModal,private languageService:CoursesService,
    private route:ActivatedRoute,
    private router:Router,
    private keywordTypeService:KeywordTypeService) {
    
      
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
          this.getLangs();
          this.getKeywords();
  }


  getKeywords(){

    this.keywordTypeService.getAll(this.id).subscribe(res=>{
      this.keywordTypes=res;
    })
  }

  openNwyKeywordType(){
    const modalref=  this.modal.open(KeywordtypeComponent, { size: 'lg' });
    modalref.componentInstance.courseid=this.id;
    modalref.result.then((result)=>{
     this.getKeywords();
    });
  }

  getLangs(){
     this.languageService.get(this.id).subscribe(res=>{
      this.course=res;
     })
  }


  openSaveModal(){
    const modalref=  this.modal.open(NewlevelComponent, { size: 'lg' });
    modalref.componentInstance.courseid=this.id;
    modalref.result.then((result)=>{
     this.getLangs();
    });

    }


    edit(data:any){
      const modalref=  this.modal.open(NewlevelComponent, { size: 'lg' });
    modalref.componentInstance.courseid=this.id;
    modalref.componentInstance.data=data;
    modalref.result.then((result)=>{
     this.getLangs();
    });
    }

    
    editType(data:any){
      const modalref=  this.modal.open(KeywordtypeComponent, { size: 'lg' });
    modalref.componentInstance.courseid=this.id;
    modalref.componentInstance.data=data;
    modalref.result.then((result)=>{
     this.getKeywords();
    });
    }

  
  detail(data:any){
    this.router.navigate(["/leveldetail/"+data])
  }
  delete(data:any){

    Swal.fire({
      title: 'Dikkat',
      text: "Bu seviye silinecek! Onaylıyor musunuz?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet',
      cancelButtonText: 'İptal',
    }).then((result) => {

     
      if (result.isConfirmed) {

          this.levelService.delete(data).subscribe(res=>{
              this.getLangs();
              Swal.fire(
                  'Başarılı!',
                  'Seviye silindi',
                  'success'
                )
          });
       
      }
    })

  }

  deleteType(data:any){

    Swal.fire({
      title: 'Dikkat',
      text: "Bu seviye silinecek! Onaylıyor musunuz?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet',
      cancelButtonText: 'İptal',
    }).then((result) => {

     
      if (result.isConfirmed) {

          this.keywordTypeService.delete(data).subscribe(res=>{
              this.getLangs();
              Swal.fire(
                  'Başarılı!',
                  'Seviye silindi',
                  'success'
                )
          });
       
      }
    })

  }

}
